const MOBILE_BREAKPOINT = parseInt(process.env.VUE_APP_MOBILE_BREAKPOINT) || 600;

export default {
    data() {
        return {
            isMobile: typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT,
        };
    },
    mounted() {
        this._onResize = () => {
            this.isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
        };
        window.addEventListener('resize', this._onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._onResize);
    },
};
